/* eslint-disable */
function pmt(rate, periods, present, future, type) {

  future = future || 0;
  type = type || 0;
  future = parseInt(future);
  type = parseInt(type);

  let pmtResult;

  if (rate === 0) {
    pmtResult = (present + future) / periods;
  } else {
    const term = Math.pow(1 + rate, periods);
    if (type === 1) {
      pmtResult = (future * rate / (term - 1) + present * rate / (1 - 1 / term)) / (1 + rate);
    } else {
      pmtResult = future * rate / (term - 1) + present * rate / (1 - 1 / term);
    }
  }
  pmtResult = Math.ceil(pmtResult * 100) / 100;

  return -pmtResult;
}

export default pmt;
